module.exports = __webpack_public_path__ + "static/media/em-93.df8ce479.png";